<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $"> 
<span *ngIf="$.row">{{getOutCome($.row[dataProperty],($.row))?.name}}</span>
</ng-container>
